import { Box, Typography } from '@mui/material'
import * as React from 'react'
import { useDashboardContext } from '@/providers/dashboard/hooks/useDashboardContext'
import { useSearchCompanies } from '@/services/suppliers/suppliers.service'
import { ICompanyCardProps } from '@/components/ui/company-card/types'
import CompanyCard from '@/components/ui/company-card'
import { PaginationComponent } from '@/components/pagination'
import { axios } from '@/lib/axios'
import { FlexGrid } from '@/components'

const baseUrl = process.env.API_BASE_URL

export const SuppliersGridCards: React.FC<any> = ({
  filterAttributes,
  filterTitle,
  currentTab,
}) => {
  const [page, setPage] = React.useState(1)
  const [filters, setFilters] = React.useState<Record<string, string[]>>({})
  const [totalPages, setTotalPages] = React.useState<number | undefined>(
    undefined,
  )
  const { params: selectedFilters, setParams } = useDashboardContext()
  const sizeItems = 15

  const dataObject = useSearchCompanies({
    ...{ ...selectedFilters, size: sizeItems, from: (page - 1) * sizeItems },
  })

  const obtainFilters = async () => {
    const res = await axios.get(`${baseUrl}/categories`)
    if (res.ok) {
      setFilters({
        dataMethods: res.data.dataMethod,
        useCases: res.data.useCases,
        geo: res.data.geo,
      })
    }
  }

  React.useEffect(() => {
    setParams({ title: selectedFilters?.title })
    obtainFilters()
  }, [])

  React.useEffect(() => {
    setPage(1)
  }, [selectedFilters])

  React.useEffect(() => {
    const dataCount = dataObject.data?.data?.count
    if (dataCount) {
      setTotalPages(Math.ceil(dataCount / sizeItems))
    }
  }, [dataObject.data?.data?.count])

  const cardsData = dataObject.data?.data?.profiles
    ? (dataObject.data?.data?.profiles as ICompanyCardProps[])
    : []

  const { isLoading, isError } = dataObject

  const cardElements = cardsData.map((card) => (
    <CompanyCard
      key={card.id}
      domain={card.domain}
      country={card.country}
      banner={card.banner}
      geo={card.geo}
      avatar={card.avatar}
      name={card.name}
      description={card.description}
      id={card.id}
      companyId={card.companyId}
      verified={card.verified}
      slogan={card.slogan}
    />
  ))

  return (
    <>
      <FlexGrid
        isLoading={isLoading}
        isError={isError}
        currentPage={page}
        pageSize={sizeItems}
        totalCount={dataObject.data?.data?.count || 0}
      >
        {cardElements}
      </FlexGrid>

      {cardElements.length > 0 && (
        <PaginationComponent
          totalPages={totalPages}
          page={page}
          setPage={setPage}
        />
      )}
    </>
  )
}
